<template>
  <div class="delete-wrap">
    <button class="btn btn-danger w-80px" @click.stop="isOpen = true">
      刪除
    </button>
    <div class="delete-dialog-wrap" v-if="isOpen" @click.stop="">
      <div class="delete-dialog block">
        <h3 class="pa-5 text-left">確定要刪除嗎</h3>
        <div class="h4 text-left px-5 pb-5">
          刪除的資料跟青春小鳥一樣一去不復返。
        </div>
        <div class="pa-5 text-right">
          <button class="btn w-100px mr-10px" @click.stop="isOpen = false">
            取消
          </button>
          <button class="btn btn-danger w-100px" @click.stop="deleteHandler">
            刪除
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    isOpen: false,
  }),
  methods: {
    deleteHandler() {
      this.$emit('confirm-delete');
      this.isOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.delete-wrap {
  width: 40px;
  height: 40px;
}

.delete-dialog-wrap {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(209, 208, 208, 0.5);
  z-index: 100;
  cursor: default;
}
.delete-dialog {
  width: 720px;
  margin: 0 auto;
  margin-top: 288px;
}
</style>
